let config = {
  locale: 'en',
};

const configStorage = {
  set(configData) {
    config = configData;
  },
  get() {
    return config;
  },
};

export default configStorage;
